// src/portals/creator/components/StatsWidget.js
import React from "react";
import { Link } from "react-router-dom";
import { ArrowUp, ArrowDown } from "lucide-react";
import Card from "../../../components/ui/Card";

const StatsWidget = ({ icon: Icon, title, value, change, href }) => {
  const isPositive = change && change.startsWith("+");

  const content = (
    // ✨ THE CARD FIX: Padding is responsive to container width
    <Card className="hover:shadow-md transition-shadow !p-3 @sm:!p-4 h-full">
      <div className="flex flex-col h-full">
        <div className="flex items-center">
          {/* ✨ Icon is smaller in small containers */}
          <div className="p-2 bg-slate-100 rounded-lg">
            <Icon className="w-5 h-5 text-primary" />
          </div>
          {change && (
            <div
              className={`ml-auto flex items-center text-xs font-semibold ${
                isPositive ? "text-green-500" : "text-red-500"
              }`}
            >
              {isPositive ? <ArrowUp size={14} /> : <ArrowDown size={14} />}
              <span className="ml-1">{change}</span>
            </div>
          )}
        </div>
        {/* ✨ Text sizes respond to container width (@sm / @xs) */}
        <div className="mt-2">
          <p className="text-[10px] @sm:text-sm text-slate-500 truncate">{title}</p>
          <p className="text-lg @sm:text-2xl font-bold text-slate-800 truncate">
            {value}
          </p>
        </div>
      </div>
    </Card>
  );

  if (href) {
    return (
      <Link to={href} className="h-full">
        {content}
      </Link>
    );
  }
  return content;
};

export default StatsWidget;
